import { createRouter, createWebHistory } from 'vue-router'
const router = createRouter({

  /**
   * @see {@link history 参数文档 } https://router.vuejs.org/zh/api/#history
   * @see {@link createWebHistory 方法文档 } https://router.vuejs.org/zh/api/#createwebhistory
   */
  history: createWebHistory(),
routes: [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/logIn.vue'),
    meta: {
      title: '登录',
    }
  },
  {
    // path:'*', redirect: '/login'
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/user.vue'),
    children: [
      {
        path: '',
        component: () => import('@/components/user/home.vue'),
        meta: {
          title: '个人首页',
        },
      },
      {
        path: 'mine',
        component: () => import('@/components/user/mine.vue'),
        meta: {
          title: '个人首页',
        },
      },
    ]
  },
  {
    path: '/agent',
    component: () => import('@/views/agent.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/components/agent/home.vue'),
        meta: {
          title: '首页',
        },
      },
      {
        path: 'agentMerchant',
        name: 'agentMerchant',
        component: () => import('@/components/agent/agentMerchant.vue'),
        meta: {
          title: '商家',
        },
      },
      {
        path: 'equipment',
        name: 'equipment',
        component: () => import('@/components/agent/equipment.vue'),
        meta: {
          title: '设备',
        },
      },
      {
        path: 'billingSetup',
        name: 'billingSetup',
        component: () => import('@/components/agent/billingSetup.vue'),
        meta: {
          title: '开票设置',
        },
      },
      {
        path: 'billingItem',
        name: 'billingItem',
        component: () => import('@/components/agent/billingItem.vue'),
        meta: {
          title: '开票项目',
        },
      },
      {
        path: 'foundListPass',
        name: 'foundListPass',
        component: () => import('@/components/agent/foundListPass.vue'),
        meta: {
          title: '商家',
        },
      },
      {
        path: 'merchantList',
        name: 'merchantList',
        component: () => import('@/components/agent/merchantList.vue'),
        meta: {
          title: '商家账号列表',
        },
      },
      {
        path: 'agentMine',
        name: 'agentMine',
        component: () => import('@/components/agent/mine.vue'),
        meta: {
          title: '我的',
        },
      },
      {
        path: 'foundList',
        name: 'foundList',
        component: () => import('@/components/agent/foundList.vue'),
        meta: {
          title: '创建',
        },
      },
      {
        path: 'foundListStats',
        name: 'foundListStats',
        component: () => import('@/components/agent/foundListStats.vue'),
        meta: {
          title: '创建',
        },
      },
      {
        path: 'equipmentMaintenance',
        name: 'equipmentMaintenance',
        component: () => import('@/components/agent/equipmentMaintenance.vue'),
        meta: {
          title: '设备运维',
        },
      },
      {
        path: 'equipmentMaintendetil',
        name: 'equipmentMaintendetil',
        component: () => import('@/components/agent/equipmentMaintendetil.vue'),
        meta: {
          title: '设备运维详情',
        },
      },
      {
        path: 'mine',
        name: 'mine',
        component: () => import('@/components/merChant/mine.vue'),
        meta: {
          title: '我的',
        },
      }
]
  },
  {
    path: '/merChant',
    component: () => import('@/views/merChant.vue'),
    children: [
      {
        path: '',
        name: 'orderInvoicing',
        component: () => import('@/components/merChant/orderInvoicing.vue'),
        meta: {
          title: '订单开票',
        },
      },
      // {
      //   path: '',
      //   name: 'makeInvoice',
      //   component: () => import('@/components/merChant/makeInvoice.vue'),
      //   meta: {
      //     title: '开票',
      //   },
      // },
      {
        path: 'multipleSettings',
        name: 'multipleSettings',
        component: () => import('@/components/merChant/multipleSettings.vue'),
        meta: {
          title: '',
        },
      },
      {
        path: 'settingsSubmit',
        name: 'settingsSubmit',
        component: () => import('@/components/merChant/settingsSubmit.vue'),
        meta: {
          title: '',
        },
      },
      // {
      //   path: 'orderInvoicing',
      //   name: 'orderInvoicing',
      //   component: () => import('@/components/merChant/orderInvoicing.vue'),
      //   meta: {
      //     title: '订单开票',
      //   },
      // },
      {
        path: 'orderInvoicingdetill',
        name: 'orderInvoicingdetill',
        component: () => import('@/components/merChant/orderInvoicingdetill.vue'),
        meta: {
          title: '订单详情',
        },
      },
      {
        path: 'multipleSubmit',
        name: 'multipleSubmit',
        component: () => import('@/components/merChant/multipleSubmit.vue'),
        meta: {
          title: '提交',
        },
      },
      {
        path: 'analyze',
        name: 'analyze',
        component: () => import('@/components/merChant/analyze.vue'),
        meta: {
          title: '分析',
        },
      },
      {
        path: 'mine',
        name: 'mine',
        component: () => import('@/components/merChant/mine.vue'),
        meta: {
          title: '我的',
        },
      }
]
  }
]
})
router.beforeEach((to, from, next) => {
  console.log(to)
  let token = localStorage.token
  let userInfo = JSON.parse(localStorage.userInfo || '{}')
  if (to.path == '/user') {
    return next()
  } else 
  if (to.path !== '/login' && !token) {
    return next('/login')
  } else if (to.path == '/' && userInfo.level == 300) {
    return next('/merChant')
  } else if (to.path == '/' && userInfo.level == 200) { 
    return next('/agent')
  } else {
    next()
  } 
  
})
export default router